import { useCallback, useEffect, useRef, useState } from "react";
import { useLocale } from "../i18n/localeContext";
import "./LanguageSwitcher.css";
import React from "react";

const LanguageSwitcher = () => {
  const { locale, setLocale } = useLocale();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const setEs = useCallback(() => setLocale("es"), [setLocale]);
  const setEn = useCallback(() => setLocale("en"), [setLocale]);

  // close on outside click
  useEffect(() => {
    const onDocClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  return (
    <div className="language-switcher lang-dropdown" ref={dropdownRef}>
      <button
        type="button"
        className="lang-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        title="Idioma"
      >
        {locale?.toUpperCase() === "EN"
          ? "ENGLISH"
          : locale?.toUpperCase() === "ES"
          ? "ESPAÑOL"
          : locale?.toUpperCase() || "ESPAÑOL"}
      </button>
      {isOpen && (
        <div className="lang-menu" role="listbox">
          <button
            type="button"
            className={`lang-pill ${locale === "es" ? "active" : ""}`}
            onClick={() => {
              setEs();
              setIsOpen(false);
            }}
            role="option"
            aria-selected={locale === "es"}
          >
            ESPAÑOL
          </button>
          <button
            type="button"
            className={`lang-pill ${locale === "en" ? "active" : ""}`}
            onClick={() => {
              setEn();
              setIsOpen(false);
            }}
            role="option"
            aria-selected={locale === "en"}
          >
            ENGLISH
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
